import React, { useState, useEffect, useCallback } from 'react'
import { useModal } from 'react-modal-hook'
import FooterServices from '../../services/footer.service'
import TermsModal from '../Modal/termsModal'
import { TERMS_CONDITIONS_KEYS } from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next'
import envConfig from 'custom/config/environment'

export default function TermsAndCondition({ module = '' }) {
  const { t } = useTranslation()
  const [dataSource, setDataSource] = useState({})

  const fetchTermsAndConditions = useCallback(async () => {
    try {
      const response = await FooterServices.getTcDetails({
        module: envConfig.TC_MODULE_TYPE === 'CUSTOM' ? module : 'GENERAL',
      })
      if (response.data['termsCondition']) {
        setDataSource(response.data['termsCondition'][0])
      }
    } catch (err) {}
  }, [])

  useEffect(() => {
    fetchTermsAndConditions()
  }, [])

  const [showModal, hideModal] = useModal(
    () => (
      <TermsModal hideModal={hideModal}>
        <div className='modal-error-body'>
          <div>
            <p
              dangerouslySetInnerHTML={{ __html: dataSource?.message || '' }}
              className='text-justify '
              style={{ height: 300, padding: 20, overflow: 'overlay',whiteSpace:'pre-line' }}></p>
          </div>
        </div>
      </TermsModal>
    ),
    [dataSource],
  )

  return (
    <div>
      <label
        className='form-check-label control-label'
        style={{ textAlign: 'center', width: '250px', margin: '0 auto', display: ' block' }}
        htmlFor='tnc'>
        {t(TERMS_CONDITIONS_KEYS.CONFIRM_MESSAGE)} 
        <span
          onClick={() => showModal()}
          style={{ color: 'blue', cursor: 'pointer',marginLeft:5 }}
          type='button'
          data-toggle='modal'
          data-target='.bd-example-modal-lg'>
          {t(TERMS_CONDITIONS_KEYS.HEADER)}
        </span>
      </label>
    </div>
  )
}
